import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import Sidebar from '../components/layout/Sidebar';

const PeoplePage = () => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="flex h-screen bg-gradient-to-br from-purple-50 via-blue-50 to-cyan-50 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%239C92AC%22%20fill-opacity%3D%220.1%22%3E%3Ccircle%20cx%3D%2230%22%20cy%3D%2230%22%20r%3D%222%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-40"></div>
      
      {/* Sidebar */}
      <Sidebar 
        isExpanded={isExpanded} 
        onToggle={() => setIsExpanded(!isExpanded)} 
      />
      
      {/* Arrow for minimized sidebar */}
      {!isExpanded && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="fixed left-16 top-8 w-6 h-6 bg-white/40 backdrop-blur-lg rounded-r-lg flex items-center justify-center text-gray-800 hover:bg-white/50 transition-all duration-500 ease-out z-[60] shadow-lg border border-white/30"
        >
          <ChevronRight size={16} />
        </button>
      )}
      
      {/* Main Content */}
      <main className={`flex-1 flex flex-col transition-all duration-500 ease-out ${isExpanded ? 'ml-72' : 'ml-16'}`}>
        <div className="flex-1 p-8 overflow-y-auto">
          <div className="max-w-7xl mx-auto">
            
            {/* Header */}
            <div className="mb-8">
              <h1 className="text-3xl font-bold text-gray-900 mb-2">People</h1>
              <p className="text-gray-600">Manage your contacts and collaborators</p>
            </div>

            {/* Coming Soon */}
            <div className="bg-white/40 backdrop-blur-lg rounded-2xl border border-white/50 shadow-xl p-12 text-center">
              <div className="text-6xl mb-4">👥</div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-2">Coming Soon</h2>
              <p className="text-gray-600">People management features are in development</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PeoplePage;
